module.exports = __webpack_public_path__ + "c5c7764f665308dcdfd27942ff25923d.svg";